import { useAtom } from "jotai";
import { beneficiosAtom, loadingAtom } from "../store/store";
import { BeneficiosService } from "services/comunicacion-cultura";
import { saveAs } from "file-saver";

const useBeneficiosPage = () => {

    const [beneficios, setBeneficios] = useAtom(beneficiosAtom);
    const [loading, setLoading] = useAtom(loadingAtom);

    const fetchBeneficios = async () => {
        const beneficios = await BeneficiosService.listar();
        setBeneficios(beneficios);
    }

    const exportar = async () => {
        try {
            setLoading(true);
            const response = await BeneficiosService.exportar();
            const filename = response?.headers?.filename;
            saveAs(response.data, filename);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error("No se pudo generar el excel");
        }
    }

    return {
        beneficios,
        loading,
        exportar,
        fetchBeneficios
    };
};

export default useBeneficiosPage;